export const cTipoInscripcion = {
    ESTUDIANTIL: 100,
    ACADEMICA: 200
}